var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-order-list"},[_vm._l((_vm.subOrders),function(subOrder,index){return [_c('SubOrderListCard',{key:index,style:({
				paddingTop:
					index === 0
						? '8px'
						: '12px',

				paddingRight: '8px',
				paddingBottom: '10px',
				paddingLeft: '6px',

				borderRadius: '10px',

				marginRight: '5px',
			}),attrs:{"despatchParty":subOrder.despatchParty,"deliveryParty":subOrder.deliveryParty,"subOrderId":subOrder.id,"edi":subOrder.edi,"etd":subOrder.etd,"atd":subOrder.atd,"isUsingAtd":Boolean(subOrder.atd && subOrder.atd.date),"eta":subOrder.eta,"ata":subOrder.ata,"isUsingAta":Boolean(subOrder.ata && subOrder.ata.date),"isCurrentSuborder":_vm.selectedSubOrder && _vm.selectedSubOrder.id === subOrder.id},on:{"click":function($event){return _vm.$emit('selected',index)}},scopedSlots:_vm._u([{key:"contextMenu",fn:function(){return [_c('t-menu',[_c('t-menu-group',[_c('t-menu-item',{attrs:{"icon":"edit"},on:{"click":function($event){return _vm.$emit('createParallelSuborder', subOrder.id)}}},[_c('strong',[_vm._v(_vm._s(_vm.$t('parallelSuborder')))])])],1)],1)]},proxy:true}],null,true)})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }